import { createApp } from 'vue';

import aelborder from './border/PandoraBorder.vue';
import aelbutton from './button/PandoraButton.vue';
import aelcalendar from './calendar/PandoraCalendar.vue';
import aelcards from './cards/PandoraCards.vue';
import aelcarrusel from './carrusel/PandoraCarrusel.vue';
import aelcarruselcontainer from './carrusel/PandoraCarruselContainer.vue';
import aelcheckbox from './checkbox/PandoraCheckbox.vue';
import aelcollapsible from './collapsible/PandoraCollapsible.vue';
import aelfooter from './footer/PandoraFooter.vue';
import aelinput from './input/PandoraInput.vue';
import aellogo from './logo/PandoraLogo.vue';
import aelmenu from './menu/PandoraMenu.vue';
import aelmodal from './modal/PandoraModal.vue';
import aelpagination from './pagination/PandoraPagination.vue';
import aelselect from './select/PandoraSelect.vue';
import aelprogressbar from './progressbar/PandoraProgressBar.vue';
import aelcarditem from './cards/PandoraCardItem.vue';
import aelsearch from './search/PandoraSearch.vue';
import aeltabs from './menu/MenuVersion/PandoraTabs.vue';
import aelradio from './radio/PandoraRadio.vue';
import aelbtnchat from './btnChat/PandoraBtnChat.vue';


const components = {
    aelborder,
    aelbutton,
    aelcalendar,
    aelcards,
    aelcarrusel,
    aelcheckbox,
    aelcollapsible,
    aelfooter,
    aelinput,
    aellogo,
    aelmenu,
    aelmodal,
    aelpagination,
    aelselect,
    aelcarruselcontainer,
    aelprogressbar,
    aelcarditem,
    aelsearch,
    aeltabs,
    aelradio,
    aelbtnchat
};

const pandora = {
    install(app) {
        Object.entries(components).forEach(([name, component]) => {
            const customName = name.replace(/^ael/, 'ael-');
            app.component(customName, component);
        });
    }
};

if (typeof window !== 'undefined' && !window._VUE_APP_) {
    const app = createApp({});
    app.use(pandora);
    app.mount('#app');
}

export default pandora;